import _ from 'lodash';
import { ORDER_COMMISSION_STATUS, TAG_TYPE } from '@/constants';

export default () => [
  {
    prop: 'id',
    label: '编号',
    width: 80,
    action: ['hide-in-detail']
  },
  {
    prop: 'status',
    label: '状态',
    renderCell(h, { row }) {
      return <el-tag type={TAG_TYPE[row.status]}>{ORDER_COMMISSION_STATUS[row.status]}</el-tag>
    }
  },
  {
    prop: 'order_so_id',
    label: '订单号',
    renderCell(h, { row }) {
      return <c-link-button to={{ name: 'orders.show', params: { id: row.order_id } }}>{row.order_so_id}</c-link-button>
    }
  },
  {
    prop: 'user',
    label: '邀请者',
    renderCell(h, { row }) {
      const { id, nickname, no } = _.get(row, 'user', {});
      return <c-link-button to={{ name: 'users.show', params: { id } }}>{nickname} - {no}</c-link-button>
    }
  },
  {
    prop: 'invitee_nickname',
    label: '消费者',
    renderCell(h, { row }) {
      return <c-link-button to={{ name: 'users.show', params: { id: row.invitee_id } }}>{row.invitee_nickname} - {row.invitee_no}</c-link-button>
    }
  },
  {
    prop: 'amount',
    label: '佣金',
  },
  {
    prop: 'created_at',
    label: '创建时间',
    renderCell: 'time',
    sort: 'order_by'
  },
  {
    prop: 'action',
    label: '操作',
    fixed: 'right',
    detail: true,
    action: ['hide-in-detail']
  }
];
